/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveHandle.defs.js'
export * as $defs from './resolveHandle.defs.js'
